// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"308":"lazy-stake-cart","500":"modal-connect-wallet","547":"modal-features"}[chunkId] + "." + {"308":"4ee19e85","500":"917e23e7","547":"156539d3"}[chunkId] + ".chunk.css";
};